angular.module('gym.subscriptions').controller('PlanChangeDisallowedModalCtrl', ["$scope", "$modalInstance", "errors", function($scope, $modalInstance, errors) {
  $scope.errors = errors;
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
